import clsx from 'clsx';
import React from 'react';
import { useParams } from 'react-router';

import { ICONS } from '@/src/components/common/Elements/Icon/Icon';
import Spinner from '@/src/components/common/Elements/Spinner/Spinner';
import { isResponseError } from '@/src/components/project/Inbox2/api/config';
import ActionButton from '@/src/components/project/Inbox2/Elements/ActionButton/ActionButton';
import { useInboxEntryPanel } from '@/src/components/project/Inbox2/store/inboxEntryPanel.store';
import { EmailEntry } from '@/src/components/project/Inbox2/types';
import useInboxSearchParams from '@/src/components/project/Inbox2/useInboxSearchParams';
import { showToast } from '@/src/globalFunction';

import { useValidateActionResponse } from '../../../../../useValidateActionResponse';
import { getCurrentEmailEntriesCountFromCache } from '../../../../api/getEmailEntries';
import { useMarkDeleteEmail } from '../../../../api/markDeleteEmail';
import { useSyncSelectedEmailEntryListItem } from '../../EmailEntries/useSyncSelectedEmailEntryListItem';

type RestoreEmailProps = {
  selectedEmailEntry: EmailEntry;
  enabled: boolean;
};

const RestoreEmail = ({ selectedEmailEntry, enabled = true }: RestoreEmailProps) => {
  const { projectId } = useParams<{ projectId: string }>();
  const { setInboxEntry } = useInboxEntryPanel();
  const restoreEmailMutation = useMarkDeleteEmail({
    projectId,
    inboxEntryId: selectedEmailEntry.inboxEntryId,
  });
  const { confirmRefreshModal } = useValidateActionResponse({
    responseError: isResponseError(restoreEmailMutation.data) ? restoreEmailMutation.data : null,
  });
  const syncEmailEntries = useSyncSelectedEmailEntryListItem({ emailEntry: selectedEmailEntry });
  const { filter } = useInboxSearchParams();

  const handleClick = async () => {
    const response = await restoreEmailMutation.mutateAsync({
      projectId,
      inboxEntryId: selectedEmailEntry.inboxEntryId,
      emailId: selectedEmailEntry.id,
      trash: false,
    });

    if (response) {
      const currentEmailEntriesCount = getCurrentEmailEntriesCountFromCache({
        projectId,
        filter,
        inboxEntryId: selectedEmailEntry.inboxEntryId,
      });

      if (currentEmailEntriesCount <= 1) {
        setInboxEntry(null);
      } else {
        syncEmailEntries();
      }

      showToast('success', 'Successfully restoreEmaile entry.');
    }
  };

  return (
    <div className="menu-content">
      {restoreEmailMutation.isLoading && <Spinner />}
      <ActionButton
        id={'restore_email'}
        className={clsx('')}
        icon={ICONS.restore}
        iconClasses={clsx('')}
        onClick={handleClick}
        tooltipSettings={{
          content: 'Restore',
          place: 'left',
        }}
        disabled={!enabled}
      />
      {confirmRefreshModal}
    </div>
  );
};

export default RestoreEmail;
